import { API_VERSION, TASK_SERVICE, X_API_VERSION } from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_WORK_ORDER_DEPENDENCY_MAP = `${TASK_SERVICE}/work-template-dependency-maps`;

export const workOrderDependencyMaps = {
  getAll: async ({ filters, sort, params, signal } = {}) => {
    const options = await apiOptions({
      url: API_WORK_ORDER_DEPENDENCY_MAP,
      method: "get",
      signal,
      params,
      filters,
      sort,
    });
    return apiRequest(options);
  },
  getById: async ({ id } = {}) => {
    const options = await apiOptions({
      url: `${API_WORK_ORDER_DEPENDENCY_MAP}/${id}`,
      method: "get",
    });
    return apiRequest(options);
  },
  create: async ({ data, toastMessageConfig = {} }) => {
    const options = await apiOptions({
      url: API_WORK_ORDER_DEPENDENCY_MAP,
      method: "post",
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  update: async ({ id, data, toastMessageConfig = {} }) => {
    const options = await apiOptions({
      url: `${API_WORK_ORDER_DEPENDENCY_MAP}/${id}`,
      method: "patch",
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  delete: async ({ id, modifiedOn, toastMessageConfig = {} }) => {
    const options = await apiOptions({
      url: `${API_WORK_ORDER_DEPENDENCY_MAP}/${id}`,
      method: "delete",
      headers: { [X_API_VERSION]: API_VERSION },
      data: { modifiedOn },
    });
    return apiRequest(options, toastMessageConfig);
  },
  updateConfigById: async ({
    id,
    data,
    modifiedOn,
    toastMessageConfig,
  } = {}) => {
    const options = await apiOptions({
      url: `${API_WORK_ORDER_DEPENDENCY_MAP}/${id}`,
      method: "patch",
      data,
      modifiedOn,
    });
    return apiRequest(options, toastMessageConfig);
  },
  getOrderTemplateWorkOrderTemplates: async ({ id }) => {
    const options = await apiOptions({
      url: `${API_WORK_ORDER_DEPENDENCY_MAP}/order-templates/${id}`,
      method: "get",
    });
    return apiRequest(options);
  },
  putOrderTemplateWorkOrderTemplates: async ({ data, id, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_WORK_ORDER_DEPENDENCY_MAP}/order-templates/${id}`,
      method: "PUT",
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
};
